export default "__VITE_ASSET__de46013c__"